import * as Sentry from "@sentry/browser";
import { SENTRY_CONF } from "@config";
import { AxiosError } from "axios";
import store from "@stores/store";

export function initSentry(): void {
  if (process.env.REACT_APP_ENV === "local") return;

  Sentry.init({
    environment: process.env.REACT_APP_DOMAIN,
    dsn: SENTRY_CONF.dsn
  });
}

export function sendReactError(
  error: Error | null,
  info: object,
  id?: number
): void {
  if (process.env.REACT_APP_ENV === "local") return;

  Sentry.withScope((scope) => {
    scope.setUser({ id: id ? id.toString() : "" });
    Object.keys(info).forEach((key) => {
      scope.setExtra(key, info[key]);
    });
    Sentry.captureException(error);
  });
}

/** AxiosErrorなのか、チェックを行う */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkAxiosError = (e: any): e is AxiosError => {
  return e.isAxiosError;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendApiError = (error: any): void => {
  if (process.env.REACT_APP_ENV === "local") return;
  if (!checkAxiosError(error)) return;
  const state = store.getState();

  if (error && (error.response === undefined || error.response.status >= 400)) {
    Sentry.withScope((scope) => {
      scope.setUser({ id: state.user.id ? state.user.id.toString() : "" });
      scope.setExtra("Request URL", error.config.url);
      if (error.response) {
        Object.entries(error.response).forEach(([key, value]) => {
          scope.setExtra(key, value);
        });
      }
      Sentry.captureException(error);
    });
  }
};
